import { render, staticRenderFns } from "./EmpInviteProvider.vue?vue&type=template&id=afffd1b8&"
import script from "./EmpInviteProvider.vue?vue&type=script&lang=js&"
export * from "./EmpInviteProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports